window.addEventListener('DOMContentLoaded', (event) => {
  // register
  const step2 = document.getElementById('step2')
  const step3 = document.getElementById('step3')

  const addError = (inputEl, errorEl, message) => {
    inputEl.classList.add('error')
    errorEl.textContent = message
    errorEl.style.display = 'block'
  }

  const removeError = (inputEl, errorEl) => {
    inputEl.classList.remove('error')
    errorEl.style.display = 'none'
  }

  const checkValidation = (number) => {
    if (number === 2) {
      // nickname
      const nicknameInput = step2.querySelector('input[name="nickname"]')
      const nicknameNextSibling = nicknameInput.nextSibling
      if (!nicknameInput.value) {
        addError(nicknameInput, nicknameNextSibling, 'ニックネームを入力してください。')
        return false

      } else {
        if (nicknameInput.value.length > 20) {
          addError(nicknameInput, nicknameNextSibling, 'ニックネームは20文字以内で入力してください。')
          return false

        } else if (nicknameInput.classList.contains('error')) {
          removeError(nicknameInput, nicknameNextSibling)
        }
      }

      // password
      const passwordInput = step2.querySelector('input[name="password"]')
      const passwordConfirmInput = step2.querySelector('input[name="password_confirmation"]')
      const passwordNextSibling = passwordInput.closest('.fieldPassword').nextSibling
      if (!passwordInput.value) {
        addError(passwordInput, passwordNextSibling, 'パスワードを入力してください。')
        return false

      } else {
        let passwordPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*()\-_=+{};:<>,.?\/]{8,}$/
        if (!passwordPattern.test(passwordInput.value)) {
          addError(passwordInput, passwordNextSibling, 'パスワードは半角の英字数字を含む8文字以上で入力してください。')
          return false

        } else if (passwordInput.classList.contains('error')) {
          removeError(passwordInput, passwordNextSibling)
        }
      }

      // password_confirmation
      const passwordConfirmNextSibling = passwordConfirmInput.closest('.fieldPassword').nextSibling
      if (!passwordConfirmInput.value) {
        addError(passwordConfirmInput, passwordConfirmNextSibling, 'パスワード(確認用)を入力してください。')
        return false

      } else {
        if (passwordInput.value && (passwordInput.value !== passwordConfirmInput.value)) {
          addError(passwordConfirmInput, passwordConfirmNextSibling, 'パスワードとパスワード(確認用)が一致していません。')
          return false

        } else if (passwordConfirmInput.classList.contains('error')) {
          removeError(passwordConfirmInput, passwordConfirmNextSibling)
        }
      }
    }

    if (number === 3) {
      // name
      const lastNameInput = step3.querySelector('input[name="last_name"]')
      const firstNameInput = step3.querySelector('input[name="first_name"]')
      const NameNextSibling = lastNameInput.closest('.textRow').nextSibling
      if (!lastNameInput.value || !firstNameInput.value) {
        addError(lastNameInput, NameNextSibling, '氏名を入力してください。')
        firstNameInput.classList.add('error')
        return false

      } else if (lastNameInput.classList.contains('error')) {
        removeError(lastNameInput, NameNextSibling)
        firstNameInput.classList.remove('error')
      }

      // name_romaji
      const lastNameRomajiInput = step3.querySelector('input[name="last_name_romaji"]')
      const firstNameRomajiInput = step3.querySelector('input[name="first_name_romaji"]')
      const NameRomajiNextSibling = lastNameRomajiInput.closest('.textRow').nextSibling
      if (!lastNameRomajiInput.value || !firstNameRomajiInput.value) {
        addError(lastNameRomajiInput, NameRomajiNextSibling, '氏名（ローマ字）を入力してください。')
        firstNameRomajiInput.classList.add('error')
        return false

      } else {
        let romajiPattern = /^[a-zA-Z]+$/
        if (!romajiPattern.test(lastNameRomajiInput.value) || !romajiPattern.test(firstNameRomajiInput.value)) {
          addError(lastNameRomajiInput, NameRomajiNextSibling, '氏名（ローマ字）は半角英字で入力してください。')
          firstNameRomajiInput.classList.add('error')
          return false

        } else if (lastNameRomajiInput.classList.contains('error')) {
          removeError(lastNameRomajiInput, NameRomajiNextSibling)
          firstNameRomajiInput.classList.remove('error')
        }
      }
    }
    return true
  }

  if (step2) {
    const nextStep3 = document.querySelector('.nextSignupStep3')
    nextStep3.addEventListener('click', function(event) {
      event.preventDefault()
      const res = checkValidation(2);
      if (res) {
        step2.style.display = 'none'
        step3.style.display = 'block'
      }
    })
  }

  if (step3) {
    const registerForm = document.getElementById('registerForm')
    const registerButton = document.querySelector('.registerButton')
    registerButton.addEventListener('click', function(event) {
      event.preventDefault()
      event.target.disabled = true
      const res = checkValidation(3)
      if (res) {
        registerForm.submit()
      } else {
        event.target.disabled = false
      }
    })
  }
})